import { Field, ImageField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  GoldBarParams,
  RenderingProps,
  TranslationOptionsParams,
} from '@/shared/shared.types';

export type C02AccordionViewMoreProps = RenderingProps<
  C02AccordionViewMoreFields,
  C02AccordionViewMoreRenderingParams
>;

export type C02AccordionViewMoreFields = {
  Headline?: Field<string>;
  AlwaysVisibleText?: RichTextField;
  HiddenText?: RichTextField;
  Image?: ImageField;
};

export type C02AccordionViewMoreRenderingParams = {
  CtaAlignment?: string;
  CtaStyle?: string;
  HeadlineAlignment?: string;
  HeadlineTag?: string;
  ImagePosition?: string;
  SupportCopyAlignment?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams &
  GoldBarParams;
